import { CallQueueType } from "@/constants/queue";
import React from "react";

export interface PersistedFilters {
  dateRangeKey: string;
  startDate: string; // ISO
  endDate: string; // ISO
  previousStartDate: string; // ISO
  previousEndDate: string; // ISO
  queues: string[];
  agents: string[];
  selectedQueueType: CallQueueType;
  searchTerm?: string;
}

export function useFilterCache(tabKey: string, dashboardId?: number | string) {
  const storageKey = React.useMemo(() => {
    const scope = dashboardId ?? "general";
    return `filterCache:${scope}:${tabKey}`;
  }, [tabKey, dashboardId]);

  const [filters, setFilters] = React.useState<PersistedFilters | null>(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      return raw ? (JSON.parse(raw) as PersistedFilters) : null;
    } catch {
      return null;
    }
  });

  const saveFilters = React.useCallback(
    (value: PersistedFilters) => {
      setFilters(value);
      try {
        localStorage.setItem(storageKey, JSON.stringify(value));
      } catch {
        // ignore
      }
    },
    [storageKey]
  );

  const clearFilters = React.useCallback(() => {
    try {
      localStorage.removeItem(storageKey);
    } catch {
      // ignore
    }
    setFilters(null);
  }, [storageKey]);

  return { filters, saveFilters, clearFilters };
}


